import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from 'react-redux';

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import ConsoleLayout from "layouts/console";
import { useLocation } from "react-router-dom";
import CrudHandler from "components/crudhandler";
import PrivateLayout from "layouts/private";
import MyPayslip from "views/private/my-payslip/index";
import FinanceView from "views/private/my-payslip/financeview";
import PreviewCOE from "views/private/final-pay/previewcoe";
import Error404 from "views/error/error404";
import { theme } from 'theme';
import { ConfigProvider } from 'antd';
import CareersLayout from "layouts/careers";
import { RequireAuth } from "auth/guards/RequireAuth";
import { RequirePasswordChange } from "auth/guards/RequirePasswordChange";
import { clearPageFilters } from "utils/index";

const App = ({auth, pageTitle}) => {

	const location = useLocation();
  	const targetLocation = location.pathname;  
	const module = location.pathname.split('/')[2];	
	const previousModule = useRef(module);

	useEffect(() => {
		window.scrollTo(0, 0);

		const container = document.getElementById("app-scroll");
		if (container) {
			container.scrollTo(0, 0);
		}
	}, [location.pathname]);

	console.log(previousModule);
	console.log(module);

	useEffect(() => {
		console.log(previousModule.current);
		if (previousModule.current !== module) {
			clearPageFilters();
		}
		previousModule.current = module;
	}, [module]);
	
  	return (
		<ConfigProvider theme={theme}>
	  	<CrudHandler />
	    <Routes>
			<Route element={<RequirePasswordChange auth={auth} />}>
				{auth.isLoggedIn && <Route path="/auth/sign-in" element={<Navigate to="/console/dashboard" replace/>} />}      	
				{auth.isLoggedIn ? (
				<>
					<Route path="/" element={<Navigate to={(targetLocation !== '/' && targetLocation !== '/auth/sign-in') ? targetLocation : '/console/dashboard'} />} />
					<Route path="console/*" element={<ConsoleLayout />} />
					<Route path="admin/*" element={<AdminLayout />} />
					<Route path="rtl/*" element={<RtlLayout />} />
					<Route path="careers/*" element={<CareersLayout />}></Route>
					<Route path="private/*" element={<PrivateLayout />}>
						<Route path="view-payslip/:empCode/:payrollId/:encodedHash/:encodedPin" element={<FinanceView />} />
						<Route path="final-pay/coe/:empId" element={<PreviewCOE />} />
					</Route>
				</>
				) : (
				<>
				<Route path="/*" element={<Navigate to="/auth/sign-in" replace />}/>
				</>
	      	)}
			</Route>
			
	        <Route path="auth/*" element={<AuthLayout />} />
	        <Route path="private/*" element={<PrivateLayout />}>
	        	<Route path="my-payslip/:empCode/:payrollId/:hash" element={<MyPayslip />} />
	        	<Route path="*" element={<Error404 />} />
	        </Route>
	    </Routes>
      </ConfigProvider>
  	);
};

const mapStateToProps = (state) => ({
	auth: state.auth,	
  });
  
const mapDispatchToProps = (dispatch) => ({

});
  
  
export default connect(mapStateToProps, mapDispatchToProps)(App);
